

import { Directive } from '@angular/core';

@Directive({
  selector: 'a[mwc-dropdown]',
  host: {
    class: 'mwc-dropdown-link'
  }
})
export class MwcDropDownADirective {
  constructor() {}
}
